import React, { useState } from "react";

function App() {
  const [messages, setMessages] = useState([
    {
      role: "ai",
      text: "Hello! 👋 I'm Y-AI. How can I help you today?"
    }
  ]);

  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  // Create a unique ID for this browser
  let userId = localStorage.getItem("yai_user_id");

  if (!userId) {
    userId = crypto.randomUUID();
    localStorage.setItem("yai_user_id", userId);
  }

  const sendMessage = async () => {
    if (!input.trim() || loading) return;

    const userMessage = input.trim();

    setMessages((prev) => [
      ...prev,
      { role: "user", text: userMessage }
    ]);

    setInput("");
    setLoading(true);

    try {
      const response = await fetch(
        "https://y-ai-api.yatharthsingh735518.workers.dev",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            prompt: userMessage,
            userId: userId
          })
        }
      );

      const data = await response.json();

      setMessages((prev) => [
        ...prev,
        {
          role: "ai",
          text: data.answer || `⚠️ ${data.error || "Unknown server error"}`
        }
      ]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        {
          role: "ai",
          text: "⚠️ I couldn't connect to my AI server."
        }
      ]);
    }

    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f7fb",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <header
        style={{
          background: "#111827",
          color: "white",
          padding: "18px",
          textAlign: "center",
          fontSize: "24px",
          fontWeight: "bold"
        }}
      >
        🗿Y-AI
      </header>

      <main
        style={{
          flex: 1,
          width: "100%",
          maxWidth: "800px",
          margin: "auto",
          padding: "20px",
          boxSizing: "border-box"
        }}
      >
        {messages.map((message, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent:
                message.role === "user" ? "flex-end" : "flex-start",
              marginBottom: "14px"
            }}
          >
            <div
              style={{
                maxWidth: "75%",
                padding: "12px 16px",
                borderRadius: "16px",
                background:
                  message.role === "user" ? "#2563eb" : "white",
                color:
                  message.role === "user" ? "white" : "#111827",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                whiteSpace: "pre-wrap"
              }}
            >
              {message.text}
            </div>
          </div>
        ))}

        {loading && (
          <div
            style={{
              background: "white",
              padding: "12px 16px",
              borderRadius: "16px",
              display: "inline-block"
            }}
          >
            Y-AI is thinking... 🤔🫪😵🤯😒
          </div>
        )}
      </main>

      <div
        style={{
          padding: "15px",
          background: "white",
          borderTop: "1px solid #ddd",
          display: "flex",
          gap: "10px"
        }}
      >
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Message Y-AI..."
          style={{
            flex: 1,
            padding: "13px",
            borderRadius: "12px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none"
          }}
        />

        <button
          onClick={sendMessage}
          disabled={loading}
          style={{
            padding: "13px 20px",
            borderRadius: "12px",
            border: "none",
            background: "#2563eb",
            color: "white",
            fontSize: "16px",
            cursor: "pointer"
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
}

export default App;
